import React, { useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";

const label = (value) => String(value || "").replace(/_/g, " ");

export const CopyCheckPanel = ({ contentType, title, text, ctaText, testId }) => {
  const [checking, setChecking] = useState(false);
  const [result, setResult] = useState(null);

  const checkCopy = async () => {
    setChecking(true);
    try {
      const response = await api.post("/admin/jev/copy-check", {
        content_type: contentType,
        title,
        text,
        cta_text: ctaText,
      });
      setResult(response.data);
    } catch (error) {
      toast.error(formatError(error));
    } finally {
      setChecking(false);
    }
  };

  return (
    <section className="border border-[#D9C3A5] bg-[#FDFBF7] p-4" data-testid={`${testId}-copy-check`}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#8C6D46]">Jev check</p>
          <h4 className="mt-1 font-semibold text-[#1E2A24]">Copy readiness</h4>
        </div>
        <button
          type="button"
          onClick={checkCopy}
          disabled={checking || !(title || text).trim()}
          className="inline-flex items-center gap-1.5 border border-[#2D5A47] px-3 py-2 text-xs font-semibold text-[#2D5A47] disabled:opacity-50"
          data-testid={`${testId}-copy-check-button`}
        >
          {checking ? <Loader2 size={14} className="animate-spin" /> : <Sparkles size={14} />}
          {checking ? "Checking…" : "Check copy"}
        </button>
      </div>
      {result && (
        <div className="mt-4 grid gap-2 text-xs sm:grid-cols-2" data-testid={`${testId}-copy-check-result`}>
          <div className="border border-[#E2DCD2] bg-white px-3 py-2">
            Clarity: <strong className="capitalize">{label(result.clarity)}</strong>
          </div>
          <div className="border border-[#E2DCD2] bg-white px-3 py-2">
            Promotional quality: <strong className="capitalize">{label(result.promotional_quality)}</strong>
          </div>
          <div className="border border-[#E2DCD2] bg-white px-3 py-2">
            Claim risk: <strong className="capitalize">{label(result.misleading_claim_risk)}</strong>
          </div>
          <div className="border border-[#E2DCD2] bg-white px-3 py-2">
            CTA: <strong>{result.incomplete_cta_probability >= 0.6 ? "Needs attention" : "Complete"}</strong>
          </div>
        </div>
      )}
    </section>
  );
};